import { render, staticRenderFns } from "./projects.vue?vue&type=template&id=b3afd978&scoped=true"
import script from "./projects.vue?vue&type=script&lang=js"
export * from "./projects.vue?vue&type=script&lang=js"
import style0 from "./projects.vue?vue&type=style&index=0&id=b3afd978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3afd978",
  null
  
)

export default component.exports